import { useState, useRef } from "react";


export default function Accordion({ items }) {
  const [open, setOpen] = useState(items[0]?.key || null);

  const toggle = (key) => {
    setOpen(prev => (prev === key ? null : key));
  };

  return (
    <div className="accordion">
      {items.map((item) => {
        const isOpen = open === item.key;

        return (
          <div key={item.key} className="acc-item">
            <button
              className={`acc-header ${isOpen ? "open" : ""}`}
              onClick={() => toggle(item.key)}
            >
              {item.title}

              <span className={`acc-arrow ${isOpen ? "rotate" : ""}`}>
                ▼
              </span>
            </button>

            <div className={`acc-body ${isOpen ? "show" : ""}`}>
              <div className="acc-content">
                {item.content}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}